<template>
  <v-container fluid class="px-0">
    <v-card elevation="2" class="mx-auto">
      <v-card-title class="white--text green darken-2 py-4 px-5 d-flex align-center">
        <v-icon left color="white">mdi-format-list-bulleted</v-icon>
        Despesas de Combustível
        <v-spacer></v-spacer>
        <v-btn
            color="white"
            outlined
            @click="$router.push({ name: 'financeiro-abastecimentos-despesas-novo' })"
        >
          <v-icon>mdi-plus</v-icon>
          <span class="ml-2 d-none d-sm-flex">Nova Despesa</span>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Filtros -->
      <v-expansion-panels v-model="panelFiltros" accordion flat>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-icon left color="primary">mdi-filter-variant</v-icon>
              <span class="font-weight-medium">Filtros de Busca</span>
              <v-spacer></v-spacer>
              <v-chip
                  v-if="filtrosAtivos > 0"
                  small
                  color="primary"
                  text-color="white"
                  class="mr-2"
              >
                {{ filtrosAtivos }} filtro{{ filtrosAtivos > 1 ? 's' : '' }} ativo{{ filtrosAtivos > 1 ? 's' : '' }}
              </v-chip>
            </div>
          </v-expansion-panel-header>
          <v-divider/>
          <v-expansion-panel-content>
            <v-card-text class="pt-0">
              <v-row dense>
                <!-- Filial -->
                <v-col cols="12" md="3">
                  <v-select
                      v-model="filtros.idfilial"
                      :items="filiaisFiltro"
                      item-text="filial"
                      item-value="idfilial"
                      label="Filial"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-office-building"
                      @change="aplicarFiltros"
                      hide-details
                  />
                </v-col>

                <!-- Veículo -->
                <v-col cols="12" md="3">
                  <v-autocomplete
                      v-model="filtros.idveiculo"
                      :items="veiculos"
                      item-text="veiculoplaca"
                      item-value="idveiculo"
                      label="Veículo/Placa"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-car"
                      @change="aplicarFiltros"
                      hide-details
                  />
                </v-col>

                <!-- Fornecedor -->
                <v-col cols="12" md="3">
                  <v-autocomplete
                      v-model="filtros.idclifor"
                      :search-input.sync="searchFornecedor"
                      :items="fornecedores"
                      :loading="carregandoFornecedores"
                      item-text="nome"
                      item-value="idcliente"
                      label="Fornecedor"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-store"
                      no-filter
                      @change="aplicarFiltros"
                      hide-details
                  />
                </v-col>

                <!-- Combustível -->
                <v-col cols="12" md="3">
                  <v-autocomplete
                      v-model="filtros.idproduto"
                      :items="produtos"
                      item-text="produto"
                      item-value="idproduto"
                      label="Combustível"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-fuel"
                      @change="aplicarFiltros"
                      hide-details
                  />
                </v-col>

                <!-- Data Inicial -->
                <v-col cols="12" md="3">
                  <v-menu
                      ref="menuDataInicial"
                      v-model="menuDataInicial"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="dataInicialFormatada"
                          label="Data Inicial"
                          prepend-inner-icon="mdi-calendar"
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          clearable
                          readonly
                          @click:clear="limparDataInicial"
                          hide-details
                      />
                    </template>
                    <v-date-picker
                        v-model="filtros.dtini"
                        locale="pt-br"
                        scrollable
                        no-title
                        :max="dataAtual"
                        @input="onDataInicialSelecionada"
                        color="green darken-2"
                    />
                  </v-menu>
                </v-col>

                <!-- Data Final -->
                <v-col cols="12" md="3">
                  <v-menu
                      ref="menuDataFinal"
                      v-model="menuDataFinal"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="dataFinalFormatada"
                          label="Data Final"
                          prepend-inner-icon="mdi-calendar"
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          clearable
                          readonly
                          @click:clear="limparDataFinal"
                          hide-details
                      />
                    </template>
                    <v-date-picker
                        v-model="filtros.dtfim"
                        locale="pt-br"
                        scrollable
                        no-title
                        :max="dataAtual"
                        @input="onDataFinalSelecionada"
                        color="green darken-2"
                    />
                  </v-menu>
                </v-col>

                <!-- Documento -->
                <v-col cols="12" md="3">
                  <v-text-field
                      v-model.number="filtros.documento"
                      label="Número do Documento"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-file-document-outline"
                      @input="debounceAplicarFiltros"
                      hide-details
                      maxlength="11"
                  />
                </v-col>

                <!-- Botão Limpar Filtros -->
                <v-col cols="12" md="3">
                  <v-btn
                      color="grey"
                      outlined
                      block
                      @click="limparFiltros"
                      height="40"
                      :disabled="filtrosAtivos === 0"
                  >
                    <v-icon left>mdi-filter-remove</v-icon>
                    Limpar Filtros
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-divider></v-divider>

      <!-- Tabela -->
      <v-card-text class="pa-0">
        <v-data-table
            :headers="headers"
            :items="despesas"
            :loading="carregando"
            :items-per-page="25"
            :footer-props="{
              'items-per-page-text': 'Itens por página:',
              'items-per-page-options': [25, 50, 100, { text: 'Todos', value: -1 }]
            }"
            class="elevation-0"
            no-data-text="Nenhuma despesa encontrada"
            loading-text="Carregando despesas..."
        >
          <!-- Slot para formatação da data -->
          <template v-slot:item.dtabastecimento="{ item }">
            <span>{{ item.dtabastecimento | formataData }}</span>
          </template>

          <!-- Slot para formatação da quantidade -->
          <template v-slot:item.quantidade="{ item }">
            <span>{{ formatarNumero(item.quantidade) }} L</span>
          </template>

          <!-- Slot para formatação do valor unitário -->
          <template v-slot:item.valorunitario="{ item }">
            <span>R$ {{ formatarNumero(item.valorunitario) }}</span>
          </template>

          <!-- Slot para formatação do valor total -->
          <template v-slot:item.valortotal="{ item }">
            <span class="font-weight-bold green--text text--darken-2">
              {{ formatarMoeda(item.valortotal) }}
            </span>
          </template>

          <!-- Slot para formatação do hodômetro -->
          <template v-slot:item.odometro="{ item }">
            <span v-if="item.odometro">{{ Number(item.odometro).toLocaleString('pt-BR') }} KM</span>
            <span v-else class="grey--text">-</span>
          </template>

          <!-- Slot para ações -->
          <template v-slot:item.acoes="{ item }">
            <v-menu bottom left offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item @click="visualizarDespesa(item)">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Visualizar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="editarDespesa(item)" disabled v-if="false">
                  <v-list-item-icon>
                    <v-icon color="orange">mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Editar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="confirmarExclusao(item)">
                  <v-list-item-icon>
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>


          <!-- Slot para o resumo no rodapé -->
          <template v-slot:body.append v-if="resumo.total > 0">
            <tr class="font-weight-bold green lighten-5">
              <td colspan="4" class="text-right pa-4">
                <!--                <strong>TOTAIS:</strong>-->
              </td>
              <td class="pa-4">
                <!--                <strong>{{ formatarNumero(resumo.totalLitros) }} L</strong>-->
              </td>
              <td class="pa-4">
                <strong>TOTAL:</strong>
              </td>
              <td class="pa-4 text-center">
                <strong class="green--text text--darken-2 text-h6">
                  {{ formatarMoeda(resumo.totalValor) }}
                </strong>
              </td>
              <td class="pa-4"></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialog de Visualização -->
    <v-dialog v-model="dialogVisualizacao" max-width="800px">
      <v-card v-if="despesaSelecionada">
        <v-card-title class="green darken-2 white--text">
          <v-icon left color="white">mdi-eye</v-icon>
          Detalhes da Despesa de Combustível
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="dialogVisualizacao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Filial:</div>
                <div class="info-value">{{ despesaSelecionada.empresa || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Veículo:</div>
                <div class="info-value">{{ despesaSelecionada.veiculo || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Fornecedor:</div>
                <div class="info-value">{{ despesaSelecionada.fornecedor || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Data do Abastecimento:</div>
                <div class="info-value">{{ despesaSelecionada.dtabastecimento | formatDate }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Combustível:</div>
                <div class="info-value">{{ despesaSelecionada.produto || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Documento:</div>
                <div class="info-value">{{ despesaSelecionada.documento || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="info-item">
                <div class="info-label">Quantidade:</div>
                <div class="info-value">{{ formatarNumero(despesaSelecionada.litros) }} L</div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="info-item">
                <div class="info-label">Valor Unitário:</div>
                <div class="info-value">R$ {{ formatarNumero(despesaSelecionada.valorunitario) }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="info-item">
                <div class="info-label">Valor Total:</div>
                <div class="info-value font-weight-bold green--text text--darken-2 text-h6">
                  {{ formatarMoeda(despesaSelecionada.valortotal) }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Hodômetro:</div>
                <div class="info-value">
                  {{ despesaSelecionada.odometro ? Number(despesaSelecionada.odometro).toLocaleString('pt-BR') + ' KM' : '-' }}
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="info-item">
                <div class="info-label">Observações:</div>
                <div class="info-value">{{ despesaSelecionada.observacao || 'Nenhuma observação' }}</div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação de Exclusão -->
    <v-dialog v-model="dialogExclusao" max-width="500px">
      <v-card>
        <v-card-title class="red darken-2 white--text">
          <v-icon left color="white">mdi-alert</v-icon>
          Confirmar Exclusão
        </v-card-title>

        <v-card-text class="pa-6 pb-2 text-center">
          <v-icon size="80" color="red" class="mb-4">mdi-delete-alert</v-icon>
          <div class="text-h6 mb-2">Tem certeza que deseja excluir esta despesa?</div>
          <div class="grey--text">
            Documento: <strong>{{ despesaParaExcluir?.documento }}</strong><br>
            Valor: <strong>{{ despesaParaExcluir ? formatarMoeda(despesaParaExcluir.valortotal) : '' }}</strong>
          </div>
          <v-alert
              type="error"
              outlined
              class="mt-4 text-left"
          >
            Esta ação não pode ser desfeita!
          </v-alert>
        </v-card-text>
        <v-divider/>

        <v-card-actions class="px-6 pb-5 pt-4">
          <v-spacer></v-spacer>
          <v-btn
              color="grey"
              outlined
              @click="dialogExclusao = false"
              :disabled="excluindo"
          >
            Cancelar
          </v-btn>
          <v-btn
              color="red"
              class="white--text"
              @click="excluirDespesa"
              :loading="excluindo"
              :disabled="excluindo"
              elevation="1"
          >
            <v-icon left>mdi-delete</v-icon>
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar para feedback -->
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        top
        right
    >
      <v-icon left color="white">{{ snackbar.icon }}</v-icon>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            color="white"
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import mixinFilial from "../../../util/mixinFilial";

export default {
  mixins: [mixinFilial],

  data() {
    return {
      carregando: false,
      carregandoFornecedores: false,
      excluindo: false,

      // Controle de painéis e dialogs
      panelFiltros: null,
      dialogVisualizacao: false,
      dialogExclusao: false,

      // Datas para filtros
      dataAtual: new Date().toISOString().substr(0, 10),
      menuDataInicial: false,
      menuDataFinal: false,

      // Dados
      despesas: [],
      veiculos: [],
      produtos: [],
      fornecedores: [],

      // Controle de busca
      searchFornecedor: null,
      aguardarBusca: null,

      // Despesa selecionada para ações
      despesaSelecionada: null,
      despesaParaExcluir: null,


      dataInicialFormatada: null,
      dataFinalFormatada: null,

      // Filtros
      filtros: {
        idfilial: null,
        idveiculo: null,
        idclifor: null, // fornecedor
        idproduto: null,
        dtini: null,
        dtfim: null,
        documento: null
      },

      // Headers da tabela
      headers: [
        { text: 'Data', value: 'dtabastecimento', width: '100px' },
        { text: 'Filial', value: 'empresa' },
        { text: 'Veículo', value: 'veiculo' },
        { text: 'Placa', value: 'placa', width: '100px' },
        { text: 'Fornecedor', value: 'fornecedor' },
        { text: 'Documento', value: 'documento', width: '100px' },
        { text: 'Valor Total', value: 'valortotal', align: 'center' , width: '160px'  },
        { text: 'Ações', value: 'acoes', align: 'center', width: '90px', sortable: false },
      ],

      rules: {
        maxLength: (max) => value => !value || value.length <= max || `Máximo ${max} caracteres`,
      },

      // Snackbar
      snackbar: {
        show: false,
        message: '',
        color: 'success',
        icon: 'mdi-check-circle',
        timeout: 4000
      }
    };
  },

  watch: {
    searchFornecedor(val) {
      this.carregarFornecedores(val);
    }
  },

  computed: {
    ...mapState(["backendUrl", "timeLimit", "usuario"]),

    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 6 &&
              v.idfilial !== 12 &&
              v.idfilial !== 25 &&
              v.idfilial !== 29 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37
          );
        });
      } else {
        return [];
      }
    },

    filtrosAtivos() {
      let count = 0;
      if (this.filtros.idfilial) count++;
      if (this.filtros.idveiculo) count++;
      if (this.filtros.idclifor) count++;
      if (this.filtros.idproduto) count++;
      if (this.filtros.dtini) count++;
      if (this.filtros.dtfim) count++;
      if (this.filtros.documento) count++;
      return count;
    },

    resumo() {
      const totalLitros = this.despesas.reduce((sum, item) => sum + (parseFloat(item.quantidade) || 0), 0);
      const totalValor = this.despesas.reduce((sum, item) => sum + (parseFloat(item.valortotal) || 0), 0);

      return {
        total: this.despesas.length,
        totalLitros,
        totalValor
      };
    }
  },

  methods: {
    async listarDespesas() {
      this.carregando = true;

      try {
        const params = {
          ...this.filtros,
          documento: parseInt(this.filtros.documento),
        };

        const response = await axios.post(`${this.backendUrl}tms/lancamento/listar`, params);


        if (response.data) {
          this.despesas = response.data || [];
        } else {
          this.despesas = [];
        }


      } catch (error) {
        console.error('Erro ao carregar despesas:', error);
        this.mostrarSnackbar('Erro ao carregar despesas de combustível', 'error');
        this.despesas = [];
      } finally {
        this.carregando = false;
      }
    },

    async carregarDados() {
      try {
        await Promise.all([
          this.listarVeiculos(),
          this.listarProdutos(),
          this.listarDespesas(),
        ]);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        this.mostrarSnackbar('Erro ao carregar dados iniciais', 'error');
      }
    },

    async listarVeiculos() {
      try {
        const response = await axios.post(`${this.backendUrl}tms/veiculo/listar`, {
          limit: 9999,
          offset: 0
        });

        if (response.data) {
          this.veiculos = response.data;
        }
      } catch (error) {
        console.error('Erro ao carregar veículos:', error);
        this.veiculos = [];
      }
    },

    async listarProdutos() {
      try {
        const response = await axios.post(`${this.backendUrl}tms/produto/listar`, {
          tipo: 'combustivel',
          limit: 9999,
          offset: 0
        });

        if (response.data) {
          this.produtos = response.data;
        }
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
        this.produtos = [];
      }
    },

    carregarFornecedores(val) {
      if (!val || val.length < 2) {
        this.fornecedores = [];
        return;
      }

      if (this.aguardarBusca) {
        clearTimeout(this.aguardarBusca);
      }

      this.aguardarBusca = setTimeout(async () => {
        this.carregandoFornecedores = true;

        try {
          const response = await axios.post(`${this.backendUrl}cliente/listar`, {
            tipo: "A,F",
            limit: 30,
            offset: 0,
            busca: val || null,
          });

          this.fornecedores = response.data.lista || [];
        } catch (error) {
          console.error('Erro ao carregar fornecedores:', error);
          this.fornecedores = [];
        } finally {
          this.carregandoFornecedores = false;
        }
      }, this.timeLimit || 500);
    },

    formatarNumero(valor) {
      if (!valor && valor !== 0) return '0,000';
      return Number(valor).toFixed(3).replace('.', ',');
    },

    formatarMoeda(valor) {
      if (!valor && valor !== 0) return 'R$ 0,00';
      return Number(valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    },

    // Métodos de filtro
    onDataInicialSelecionada(val) {
      this.dataInicialFormatada = this.formatarDataInput(val);
      this.menuDataInicial = false;
      this.aplicarFiltros();
    },

    onDataFinalSelecionada(val) {
      this.dataFinalFormatada = this.formatarDataInput(val);
      this.menuDataFinal = false;
      this.aplicarFiltros();
    },

    formatarDataInput(data) {
      if (!data) return '';
      const [ano, mes, dia] = data.split('-');
      return `${dia}/${mes}/${ano}`;
    },

    limparDataInicial() {
      this.filtros.dtini = null;
      this.dataInicialFormatada = null;
      this.aplicarFiltros();
    },

    limparDataFinal() {
      this.filtros.dtfim = null;
      this.dataFinalFormatada = null;
      this.aplicarFiltros();
    },

    aplicarFiltros() {
      this.listarDespesas();
    },

    debounceAplicarFiltros() {
      if (this.aguardarBusca) {
        clearTimeout(this.aguardarBusca);
      }
      this.aguardarBusca = setTimeout(() => {
        this.aplicarFiltros();
      }, 500);
    },

    limparFiltros() {
      this.dataInicialFormatada=null;
      this.dataFinalFormatada=null;
      this.filtros = {
        idfilial: null,
        idveiculo: null,
        idclifor: null, //fornecedor
        idproduto: null,
        dtini: null,
        dtfim: null,
        documento: null
      };
      this.aplicarFiltros();
    },

    // Métodos de ações
    visualizarDespesa(item) {
      this.despesaSelecionada = { ...item };
      this.dialogVisualizacao = true;
    },

    editarDespesa(item) {
      this.$router.push({
        name: 'financeiro-abastecimentos-despesas-novo',
        params: { id: item.idlancamento }
      });
    },

    confirmarExclusao(item) {
      this.despesaParaExcluir = { ...item };
      this.dialogExclusao = true;
    },

    async excluirDespesa() {
      if (!this.despesaParaExcluir) return;

      this.excluindo = true;

      const payload = {
        ...this.despesaParaExcluir,
        acao: "D",
        documento: parseInt(this.despesaParaExcluir.documento),
        odometro: parseInt(this.despesaParaExcluir.odometro),
      };

      try {
        await axios.post(`${this.backendUrl}tms/veiculo/inserir`,payload );

        this.mostrarSnackbar('Despesa excluída com sucesso!', 'success');
        this.dialogExclusao = false;
        this.despesaParaExcluir = null;
        this.listarDespesas();

      } catch (error) {
        console.error('Erro ao excluir despesa:', error);
        this.mostrarSnackbar('Erro ao excluir despesa', 'error');
      } finally {
        this.excluindo = false;
      }
    },

    mostrarSnackbar(message, type = 'success') {
      const config = {
        success: { color: 'success', icon: 'mdi-check-circle' },
        error: { color: 'error', icon: 'mdi-alert-circle' },
        warning: { color: 'warning', icon: 'mdi-alert' },
        info: { color: 'info', icon: 'mdi-information' }
      };

      this.snackbar = {
        show: true,
        message,
        color: config[type]?.color || 'success',
        icon: config[type]?.icon || 'mdi-check-circle',
        timeout: 4000
      };
    }
  },

  mounted() {
    this.carregarDados();
  }
};
</script>

<style scoped>
.info-item {
  margin-bottom: 16px;
}

.info-label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 4px;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table >>> th {
  background-color: #f5f5f5 !important;
  font-weight: 600 !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 16px 0 0 0;
}
</style>